import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.4" clip-path="url(#clip0_3886_118991)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.22554 1.30187C6.10515 0.937527 7.04792 0.75 8 0.75C8.95208 0.75 9.89484 0.937527 10.7745 1.30187C11.6541 1.66622 12.4533 2.20025 13.1265 2.87348C13.7997 3.5467 14.3338 4.34593 14.6981 5.22554C15.0625 6.10516 15.25 7.04792 15.25 8C15.25 8.95208 15.0625 9.89484 14.6981 10.7745C14.3338 11.6541 13.7997 12.4533 13.1265 13.1265C12.4533 13.7997 11.6541 14.3338 10.7745 14.6981C9.89484 15.0625 8.95208 15.25 8 15.25C7.04792 15.25 6.10516 15.0625 5.22554 14.6981C4.34593 14.3338 3.5467 13.7997 2.87348 13.1265C2.20025 12.4533 1.66622 11.6541 1.30187 10.7745C0.937527 9.89484 0.75 8.95208 0.75 8C0.75 7.04792 0.937527 6.10516 1.30187 5.22554C1.66622 4.34593 2.20025 3.5467 2.87348 2.87348C3.5467 2.20025 4.34593 1.66622 5.22554 1.30187ZM8 1.96756C7.20781 1.96756 6.42337 2.12359 5.69148 2.42675C4.95959 2.72991 4.29458 3.17425 3.73442 3.73442C3.17425 4.29458 2.72991 4.95959 2.42675 5.69148C2.12359 6.42337 1.96756 7.20781 1.96756 8C1.96756 8.79219 2.12359 9.57663 2.42675 10.3085C2.72991 11.0404 3.17425 11.7054 3.73442 12.2656C4.29458 12.8257 4.95959 13.2701 5.69148 13.5733C6.42337 13.8764 7.20781 14.0324 8 14.0324C8.79219 14.0324 9.57663 13.8764 10.3085 13.5733C11.0404 13.2701 11.7054 12.8257 12.2656 12.2656C12.8257 11.7054 13.2701 11.0404 13.5733 10.3085C13.8764 9.57663 14.0324 8.79219 14.0324 8C14.0324 7.20781 13.8764 6.42337 13.5733 5.69148C13.2701 4.9596 12.8257 4.29458 12.2656 3.73442C11.7054 3.17425 11.0404 2.72991 10.3085 2.42675C9.57663 2.12359 8.79219 1.96756 8 1.96756Z"
        fill="#151718"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6442 6.0937C10.882 6.33144 10.882 6.7169 10.6442 6.95464L7.69256 9.9063C7.45481 10.144 7.06936 10.144 6.83161 9.9063L5.35579 8.43047C5.11804 8.19273 5.11804 7.80727 5.35579 7.56953C5.59353 7.33179 5.97899 7.33179 6.21673 7.56953L7.26209 8.61488L9.78327 6.0937C10.021 5.85596 10.4065 5.85596 10.6442 6.0937Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_3886_118991">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CheckFull = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default CheckFull;
